export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[720px] bg-background-50 flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-100/50 to-background-50 pointer-events-none z-[1]"></div>

      <div className="relative z-[2] w-full max-w-[1440px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center gap-10 lg:gap-0 pt-[100px] pb-16">
        <div className="w-full lg:w-[58%] flex flex-col items-start">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-500 text-background-950 text-sm font-bold mb-6">
            🔥 全网黑料追踪
          </span>

          <h1 className="text-[48px] md:text-[64px] font-heading font-black text-foreground-50 leading-[1.1] tracking-tight max-w-[600px]">
            五一吃瓜网
            <br />
            网红塌房前线
          </h1>

          <p className="mt-4 text-lg text-foreground-400 font-medium">
            24小时滚动爆料，全网热点一手掌握
          </p>

          <div className="mt-6 max-w-[560px] space-y-3">
            <p className="text-sm text-foreground-500 leading-relaxed">
              五一吃瓜网官网入口每日更新网红黑料与网络热门事件吃瓜爆料，覆盖娱乐圈、直播圈、短视频圈等全网八卦，实时追踪塌房现场，让你吃瓜不迷路。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed">
              本站聚合全网最全扒皮帖、曝光门、翻车实锤，提供五一吃瓜网最新地址与在线观看入口，是追热点吃瓜党的每日必刷阵地。
            </p>
          </div>

          <div className="mt-8 flex items-center gap-8 md:gap-12">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-black text-accent-500 font-heading">
                15,000+
              </p>
              <p className="text-xs text-foreground-500 mt-1">累计爆料条数</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-black text-accent-500 font-heading">
                2,300+
              </p>
              <p className="text-xs text-foreground-500 mt-1">今日更新吃瓜</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-black text-accent-500 font-heading">
                98%
              </p>
              <p className="text-xs text-foreground-500 mt-1">热点同步准确率</p>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-1.5 px-7 py-3 rounded-full bg-accent-500 text-background-950 font-bold text-sm hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              🔥 今日热榜
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#app"
              className="inline-flex items-center justify-center gap-1.5 px-7 py-3 rounded-full border border-foreground-300/30 text-foreground-100 font-bold text-sm hover:border-accent-500 hover:text-accent-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              📱 下载APP
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="w-full lg:w-[42%] flex items-center justify-center lg:justify-end">
          <div className="relative w-[320px] md:w-[420px] aspect-[3/4] rounded-3xl overflow-hidden bg-background-300">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20collage%20style%20editorial%20visual%20featuring%20glowing%20smartphone%20screen%20with%20breaking%20news%20alerts%2C%20scattered%20newspaper%20clippings%2C%20mysterious%20silhouettes%2C%20neon%20green%20accents%20on%20deep%20black%20background%2C%20modern%20social%20media%20gossip%20aesthetic%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20high%20contrast%2C%20editorial%20magazine%20quality&width=840&height=1120&seq=hero-main-visual-2026&orientation=portrait"
              alt="五一吃瓜网主视觉"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>

            <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-foreground-50/90 text-background-950 text-xs font-bold">
              实时更新
            </span>

            <div className="absolute bottom-5 left-5 right-5">
              <p className="text-xs text-foreground-300/70 mb-1">今日 Top1 爆料</p>
              <p className="text-sm font-bold text-foreground-50 leading-snug">
                某千万粉丝网红塌房全记录
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}